import React from "react"
import { Table } from 'react-bootstrap'
import { getDateOnly } from '../../../helpers/formatDate'
import { formatMoney } from '../../../helpers/utils'
import { CHARGE_STATUS_OPTIONS, DOCUMENT_TYPE_OPTIONS } from '../../constants/chargeStatus'

function ChargesTable({ data, showModel }) {

  const getTdClass = (baseClass, value) => {
    const isDefault = value === "N/A" || value === "-";
    return `${baseClass} ${isDefault ? "td-align-center" : ""}`;
  };

  return (
    <Table hover responsive>
      <thead className="table-header-gray">
        <tr>
          <th><span className="th-header-text">FECHA DE DOCUMENTO</span></th>
          <th><span className="th-header-text">FECHA DE VENCIMIENTO</span></th>
          <th><span className="th-header-text">USUARIO</span></th>
          <th><span className="th-header-text">NOMBRE DE CLIENTE</span></th>
          <th><span className="th-header-text"># DE DOCUMENTO</span></th>
          <th><span className="th-header-text">TIPO DE COBRO</span></th>
          <th><span className="th-header-text">TOTAL A COBRAR</span></th>
          <th><span className="th-header-text">DESCUENTO</span></th>
          <th><span className="th-header-text">PAGADO</span></th>
          <th><span className="th-header-text">SALDO</span></th>
          <th><span className="th-header-text">COBRO ASOCIADO</span></th>
          <th><span className="th-header-text">ESTADO</span></th>
        </tr>
      </thead>
      <tbody>
        {data?.map((model, index) => {
          const header_created_date = getDateOnly(model.header_created_date) || "N/A";
          const document_due_date = (model.document_type === "DR" || model.document_type === "P")
            ? "N/A"
            : (getDateOnly(model.document_due_date) || "N/A");
          const document_reference = model.document_reference || "N/A";
          const document_total = model.document_total != null ? formatMoney(model.document_total) : "-";
          const early_payment_discount_amount = model.document_total != null ? formatMoney(model.early_payment_discount_amount) : "-";
          const document_amount = model.document_amount != null ? formatMoney(model.document_amount) : "-";
          const pending_balance = model.pending_balance != null ? formatMoney(model.pending_balance) : "-";

          return (
            <tr
              onClick={() => showModel(model.header_db_ref)}
              className="cursor-pointer"
              key={index}
            >
              <td className={getTdClass("td-text-limited", header_created_date)}>{header_created_date}</td>
              <td className={getTdClass("td-text-limited", document_due_date)}>{document_due_date}</td>
              <td className={getTdClass("td-text-limited", `${model.header_user_uid || "-"} - ${model.header_user_full_name || "-"}`)}>
                {(model.header_user_uid || "-")} - {(model.header_user_full_name || "-")}
              </td>
              <td className={getTdClass("td-text-limited", `${model.header_client_uid || "-"} - ${model.header_client_name || "-"}`)}>
                {(model.header_client_uid || "-")} - {(model.header_client_name || "-")}
              </td>
              <td className={getTdClass("td-text-limited", document_reference)}>{document_reference}</td>
              <td className={getTdClass("td-text-limited", DOCUMENT_TYPE_OPTIONS[model.document_type] || model.document_type || "-")}>
                {DOCUMENT_TYPE_OPTIONS[model.document_type] || model.document_type || "-"}
              </td>
              <td className={getTdClass("td-text-limited td-align-right", document_total)}>{document_total}</td>
              <td className={getTdClass("td-text-limited td-align-right", early_payment_discount_amount)}>{early_payment_discount_amount}</td>
              <td className={getTdClass("td-text-limited td-align-right", document_amount)}>{document_amount}</td>
              <td className={getTdClass("td-text-limited td-align-right", pending_balance)}>{pending_balance}</td>
              <td className={getTdClass("td-text-limited", model.header_db_ref || "-")}>
                {model.header_db_ref ? (
                  <a
                    className="ubiqua-link"
                    href={`/Cobros/${model.header_db_ref}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {model.header_db_ref}
                  </a>
                ) : (
                  "-"
                )}
              </td>
              <td className={getTdClass("td-text-limited", CHARGE_STATUS_OPTIONS[model.header_status]?.label || "-")}>
                {CHARGE_STATUS_OPTIONS[model.header_status] ? (
                  <div className={CHARGE_STATUS_OPTIONS[model.header_status].className}>
                    {CHARGE_STATUS_OPTIONS[model.header_status].label}
                  </div>
                ) : (
                  "-"
                )}
              </td>
            </tr>
          );
        })}

        {data?.length === 0 && (
          <tr>
            <td colSpan="12" className="td-text-limited td-text-limited-space">
              No hay documentos disponibles en estos momentos.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default ChargesTable
